var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    class: `fill-current  text-${_vm.color}`,
    attrs: {
      "height": `${_vm.height}px`,
      "width": `${_vm.width}px`,
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M13.6981 1.6665C14.2437 1.6665 14.7668 1.88435 15.1487 2.26936L17.7328 4.85344C18.1176 5.23817 18.3337 5.75998 18.3337 6.30407C18.3337 6.84816 18.1176 7.36997 17.7328 7.7547L8.29825 17.1863C7.71618 17.8577 6.89108 18.2703 5.94583 18.3351H1.66699V17.5018L1.6697 13.9893C1.74069 13.1105 2.14921 12.2934 2.77241 11.7444L12.2465 2.27036C12.6307 1.88386 13.1531 1.6665 13.6981 1.6665ZM5.88698 16.6705C6.33216 16.639 6.74656 16.4318 7.07932 16.0512L13.3809 9.7496L10.2523 6.62083L3.91374 12.9578C3.57612 13.2564 3.36725 13.6742 3.33366 14.0564V16.669L5.88698 16.6705ZM11.4309 5.44246L14.5594 8.57109L16.5543 6.57619C16.6265 6.50402 16.667 6.40613 16.667 6.30407C16.667 6.20201 16.6265 6.10412 16.5543 6.03195L13.9679 3.44555C13.8966 3.37363 13.7994 3.33317 13.6981 3.33317C13.5968 3.33317 13.4997 3.37363 13.4283 3.44555L11.4309 5.44246Z"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }